import { CtaBand } from "../components/CtaBand";
import { Hero } from "../components/Hero";
import { IntroSection } from "../components/IntroSection";
import { ShowcaseCarousel } from "../components/ShowcaseCarousel";

export function HomePage() {
  return (
    <>
      <Hero />
      <IntroSection />
      <ShowcaseCarousel />
      <CtaBand />
    </>
  );
}
